import {ActivatedRouteSnapshot, Route} from "@angular/router";
import {inject} from "@angular/core";
import {ApiService} from "@/app/api";
import {catchError, throwError} from "rxjs";
import {guardCoachesEdit, guardCoachesWatch} from "@/app/routes/guards/coaches-guard";

const NAME = 'Тренеры'

export const coaches: Route[] = [
    {
        path: 'coaches',
        loadComponent: () => import('@components/guides/coaches/coaches.component').then(c => c.CoachesComponent),
        canActivate: [guardCoachesWatch],
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: null},
            ],
            title: NAME,
            reuse: true,
            searchString: true
        },

    },
    {
        path: 'coaches/create',
        loadComponent: () => import('@components/guides/coaches/create-coach/create-coach.component').then(c => c.CreateCoachComponent),
        canActivate: [guardCoachesEdit],
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: '/coaches/'},
            ],
        },

    },
    {
        path: 'coaches/:id',
        canActivate: [guardCoachesWatch],
        loadComponent: () => import('@components/guides/coaches/coaches-details/coaches-details.component').then(c => c.CoachesDetailsComponent),
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: '/coaches/'},
            ],
        },
        resolve: {
            coach: (route: ActivatedRouteSnapshot) => {
                const api = inject(ApiService);
                return api.Coaches.getById(route.params['id']).pipe(
                    catchError(() => {
                        // Возвращаем fallback или пробрасываем ошибку
                        return throwError(() => new Error('Coach not found'));
                    })
                )
            }
        }

    },
]
